<template>
  <g>
    <rect x="2" y="2" width="9" height="9" rx="2" :fill="iconColor" />
    <rect x="13" y="2" width="9" height="9" rx="2" :fill="iconColor" />
    <rect x="2" y="13" width="9" height="9" rx="2" :fill="iconColor" />
    <rect x="13" y="13" width="9" height="9" rx="2" :fill="iconColor" />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#3c3c3c"
    }
  }
};
</script>
